// 基于Figma设计稿提取的字体tokens
export const typography = {
  fontFamily: {
    primary: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'Monaco, "Cascadia Code", "Segoe UI Mono", "Roboto Mono", Consolas, "Courier New", monospace',
  },
  
  fontSize: {
    xs: '0.6875rem',      // 11px
    sm: '0.75rem',        // 12px  
    base: '0.875rem',     // 14px
    lg: '0.9375rem',      // 15px
    xl: '1.375rem',       // 22px
    '2xl': '1.4375rem',   // 23px
    '3xl': '2.109375rem', // 33.75px
    '4xl': '2.5rem',      // 40px
    '5xl': '3rem',        // 48px
  },
  
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  lineHeight: {
    tight: 1.025,
    snug: 1.125,
    normal: 1.25,
    relaxed: 1.3,
    loose: 1.6,
  },
  
  letterSpacing: {
    tighter: '-1.07%',
    tight: '-1.05%',
    normal: '0%',
    wide: '1.05%',
    wider: '1.08%',
    widest: '1.1%',
  },
  
  textTransform: {
    uppercase: 'uppercase',
    lowercase: 'lowercase',
    capitalize: 'capitalize',
    none: 'none',
  },
  
  // 预定义文本样式
  styles: {
    h1: {
      fontSize: '3xl',
      fontWeight: 'light',
      lineHeight: 'tight',
      letterSpacing: 'tighter',
    },
    h2: {
      fontSize: '2xl',
      fontWeight: 'light', 
      lineHeight: 'snug',
      letterSpacing: 'tight',
    },
    h3: {
      fontSize: 'xl',
      fontWeight: 'light',
      lineHeight: 'normal',
      letterSpacing: 'tight',
    },
    body: {
      fontSize: 'lg',
      fontWeight: 'light',
      lineHeight: 'loose',
      letterSpacing: 'wide',
    },
    caption: {
      fontSize: 'xs',
      fontWeight: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'wider',
      textTransform: 'uppercase',
    },
    button: {
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'tight',
      letterSpacing: 'normal',
    }
  }
};

export default typography;
